function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7248_10046)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM9.85375 8.35375L7.35375 10.8538C7.3073 10.9002 7.25215 10.9371 7.19145 10.9622C7.13075 10.9873 7.0657 11.0003 7 11.0003C6.93431 11.0003 6.86925 10.9873 6.80855 10.9622C6.74786 10.9371 6.69271 10.9002 6.64625 10.8538C6.5998 10.8073 6.56295 10.7521 6.53781 10.6914C6.51266 10.6308 6.49972 10.5657 6.49972 10.5C6.49972 10.4343 6.51266 10.3692 6.53781 10.3086C6.56295 10.2479 6.5998 10.1927 6.64625 10.1462L8.79313 8L6.64625 5.85375C6.55243 5.75993 6.49972 5.63268 6.49972 5.5C6.49972 5.36732 6.55243 5.24007 6.64625 5.14625C6.74007 5.05243 6.86732 4.99972 7 4.99972C7.13268 4.99972 7.25993 5.05243 7.35375 5.14625L9.85375 7.64625C9.90024 7.69269 9.93712 7.74783 9.96228 7.80853C9.98744 7.86923 10.0004 7.93429 10.0004 8C10.0004 8.06571 9.98744 8.13077 9.96228 8.19147C9.93712 8.25217 9.90024 8.30731 9.85375 8.35375Z",
  fill: "#1B75BB"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7248_10046"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgCircleChevron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevron);
export default __webpack_public_path__ + "static/media/circle-chevron.113d7ba3.svg";
export { ForwardRef as ReactComponent };